// test2939
(2939 && 0);
